import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5001';
const API_URL = `${API_BASE}/api/users`;
const STORAGE_KEY = 'tellurvision_auth';

interface AuthStorageShape {
  token?: string;
}

export interface MyCampaign {
  id: string;
  amount: number;
  currency: string;
  status: string;
  createdAt?: string;
  packageId?: string | null;
  packageName?: string | null;
  adId?: string | null;
  adTitle?: string | null;
  adThumbnailUrl?: string | null;
  views?: number | null;
  clicks?: number | null;
  socialClicks?: number | null;
}

function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthStorageShape;
    return typeof parsed.token === 'string' ? parsed.token : null;
  } catch {
    return null;
  }
}

export const fetchMyCampaigns = async (): Promise<MyCampaign[]> => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await axios.get<MyCampaign[]>(`${API_URL}/campaigns`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
